export const OPERATE_TYPE = {
  USER_SHARE: 0,
  USER_NEW: 1
}

export const OPERATE_TYPE_MAP = {
  [OPERATE_TYPE.USER_SHARE]: '用户分享活动',
  [OPERATE_TYPE.USER_NEW]: '新用户领券活动'
}

export const TAB_TYPE = {
  FINISHED: 'finishedList',
  UNFINISHED: 'unfinished'
}

export const TAB_TYPE_MAP = {
  [TAB_TYPE.FINISHED]: '已完成',
  [TAB_TYPE.UNFINISHED]: '未完成'
}
